<template>
  <div class="modern-youth-page">
    <v-container class="youth-container">


      <!-- Hero Image Card -->
      <div class="hero-card">
        <div class="hero-image-wrapper">
          <v-img
            :src="require('@/assets/ahmad-kadhim-GeHVEDrqMB8-unsplash.jpg')"
            class="hero-image"
            height="400"
          >
            <div class="hero-overlay">
              <div class="hero-content">
                <v-icon color="white" size="64" class="mb-4">mdi-account-multiple</v-icon>
                <h2 class="hero-title">நமது இளைஞர் குழு</h2>
                <p class="hero-subtitle">A New Dawn for Our Tamil Community</p>
              </div>
            </div>
          </v-img>
        </div>
      </div>

      <!-- Stats Cards -->
      <v-row class="stats-row">
        <v-col cols="12" sm="6" md="3">
          <div class="stat-card talent">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-lightbulb-on</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Showcase</div>
              <div class="stat-value">Talents</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="stat-card connect">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-account-heart</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Connect</div>
              <div class="stat-value">Youth</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="stat-card culture">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-book-open-variant</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Preserve</div>
              <div class="stat-value">Culture</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="stat-card service">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-hand-heart</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Serve</div>
              <div class="stat-value">Community</div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Content Cards -->
      <v-row class="content-row">
        <v-col cols="12" md="4">
          <div class="content-card card-1">
            <div class="card-icon">
              <v-icon color="white" size="40">mdi-flag-variant</v-icon>
            </div>
            <h3 class="card-title">புதியதொரு உதயம்</h3>
            <p class="card-text">
              நமது தமிழ் சங்கத்தின் புதியதொரு உதயம். பெருமிதத்துடன் ஒரு அத்தியாயம். நமது இளைஞர் குழு.
            </p>
            <div class="card-badge">New Beginning</div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="content-card card-2">
            <div class="card-icon">
              <v-icon color="white" size="40">mdi-account-star</v-icon>
            </div>
            <h3 class="card-title">திறமைகள் வளர்ச்சி</h3>
            <p class="card-text">
              பலவகையான திறமைகளைத் தன்னுள் கொண்ட நமது இளைய தலைமுறை அவற்றை வெளிகொணரவும், தம்மைப்போல் ஆர்வமுள்ள பிற இளைஞர்களை சந்திக்கவும், தங்களது தமிழார்வத்தையும் கலாச்சார பற்றையும் வளர்த்துக் கொள்ளவும் வேண்டுமென்ற நோக்கத்தோடு இந்த குழு ஆரம்பிக்கப்பட்டது.
            </p>
            <div class="card-badge">Talent Development</div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="content-card card-3">
            <div class="card-icon">
              <v-icon color="white" size="40">mdi-hands-pray</v-icon>
            </div>
            <h3 class="card-title">சமுதாய சேவை</h3>
            <p class="card-text">
              தமது திறமையை வெளிக்காட்டும் ஒரு வடிகாலாக மட்டும் இல்லாமல், சமுதாயத்துக்கு அவர்களால் ஆன உதவிகளை செய்யும் ஒரு களமாகவும் இந்த இளைஞர் அமைப்பு செயல்பட்டு வருகிறது.
            </p>
            <div class="card-badge">Community Service</div>
          </div>
        </v-col>
      </v-row>

      <!-- Call to Action -->
      <div class="cta-section">
        <div class="cta-card">
          <div class="cta-icon">
            <v-icon color="white" size="48">mdi-account-plus</v-icon>
          </div>
          <h2 class="cta-title">Join Our Youth Committee</h2>
          <p class="cta-text">
            Be part of a vibrant community of young Tamil leaders. Share your talents, connect with peers, and make a difference!
          </p>
          <v-btn
            class="cta-button"
            x-large
            rounded
            href="https://docs.google.com/forms/d/1DnRC8N95ws6GE06xYhv7bD_glLqC74mvXcpJEL2Vb2U/viewform?edit_requested=true"
            target="_blank"
          >
            <v-icon left>mdi-pencil</v-icon>
            Sign Up Here
          </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'YouthCommittee',
  data() {
    return {
      texts: [
        'நமது தமிழ் சங்கத்தின் புதியதொரு உதயம். பெருமிதத்துடன் ஒரு அத்தியாயம்.நமது இளைஞர் குழு.',
        'பலவகையான திறமைகளைத் தன்னுள் கொண்ட நமது இளைய தலைமுறை அவற்றை வெளிகொணரவும், தம்மைப்போல் ஆர்வமுள்ள பிற இளைஞர்களை சந்திக்கவும், தங்களது தமிழார்வத்தையும் கலாச்சார பற்றையும் வளர்த்துக் கொள்ளவும் வேண்டுமென்ற நோக்கத்தோடு இந்த குழு ஆரம்பிக்கப்பட்டது.',
        'தமது திறமையை வெளிக்காட்டும் ஒரு வடிகாலாக மட்டும் இல்லாமல் , சமுதாயத்துக்கு அவர்களால் ஆன உதவிகளை செய்யும் ஒரு களமாகவும் இந்த இளைஞர் அமைப்பு செயல்பட்டு வருகிறது.',
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.modern-youth-page {
  background: linear-gradient(135deg, #fdfeff 0%, #f0f4f8 50%, #e8f0f7 100%);
  min-height: 100vh;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(142, 191, 66, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(102, 126, 234, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
}

.youth-container {
  max-width: 100%;
  padding: 24px 16px;
  position: relative;
  z-index: 1;
}

/* Page Header */
.page-header {
  text-align: center;
  margin-bottom: 24px;
  position: relative;
  padding: 18px 20px;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 252, 255, 0.9) 50%,
    rgba(240, 248, 255, 0.95) 100%);
  border-radius: 20px;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.6) 50%,
      transparent 100%);
    animation: shine 3s infinite;
  }
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  margin: 0 auto 10px;
  background: linear-gradient(135deg, #8ebf42 0%, #7aa838 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 8px 20px rgba(142, 191, 66, 0.3),
    0 2px 8px rgba(122, 168, 56, 0.2);
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-subtitle {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* Hero Card */
.hero-card {
  margin-bottom: 24px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 1);
}

.hero-image-wrapper {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
}

.hero-image {
  border-radius: 24px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(142, 191, 66, 0.85) 0%,
    rgba(102, 126, 234, 0.85) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  text-align: center;
  color: white;
  padding: 20px;
}

.hero-title {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 8px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 500;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Stats Cards */
.stats-row {
  margin-bottom: 32px;
}

.stat-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 252, 255, 0.95) 100%);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
  }

  &.talent::before {
    background: linear-gradient(90deg, #8ebf42 0%, #7aa838 100%);
  }

  &.connect::before {
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  }

  &.culture::before {
    background: linear-gradient(90deg, #FF9800 0%, #F57C00 100%);
  }

  &.service::before {
    background: linear-gradient(90deg, #2196F3 0%, #1976D2 100%);
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 1);
  }
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .talent & { background: linear-gradient(135deg, #8ebf42 0%, #7aa838 100%); }
  .connect & { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
  .culture & { background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%); }
  .service & { background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%); }
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 20px;
  font-weight: 800;

  .talent & { color: #8ebf42; }
  .connect & { color: #667eea; }
  .culture & { color: #FF9800; }
  .service & { color: #2196F3; }
}

/* Content Cards */
.content-row {
  margin-bottom: 32px;
}

.content-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 252, 255, 0.95) 100%);
  border-radius: 20px;
  padding: 28px;
  height: 100%;
  box-shadow:
    0 6px 20px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
  }

  &.card-1::before {
    background: linear-gradient(90deg, #8ebf42 0%, #7aa838 100%);
  }

  &.card-2::before {
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  }

  &.card-3::before {
    background: linear-gradient(90deg, #FF9800 0%, #F57C00 100%);
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow:
      0 12px 32px rgba(0, 0, 0, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 1);
  }
}

.card-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);

  .card-1 & { background: linear-gradient(135deg, #8ebf42 0%, #7aa838 100%); }
  .card-2 & { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
  .card-3 & { background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%); }
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 14px;
  line-height: 1.3;
}

.card-text {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 16px;
}

.card-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: white;

  .card-1 & {
    background: linear-gradient(135deg, #8ebf42 0%, #7aa838 100%);
    box-shadow: 0 4px 12px rgba(142, 191, 66, 0.3);
  }

  .card-2 & {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  .card-3 & {
    background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
    box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
  }
}

/* CTA Section */
.cta-section {
  margin-top: 40px;
}

.cta-card {
  background: linear-gradient(135deg,
    rgba(142, 191, 66, 0.95) 0%,
    rgba(102, 126, 234, 0.95) 100%);
  border-radius: 24px;
  padding: 48px 32px;
  text-align: center;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.2) 50%,
      transparent 100%);
    animation: shine 4s infinite;
  }
}

.cta-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.2),
    inset 0 2px 0 rgba(255, 255, 255, 0.3);
}

.cta-title {
  font-size: 32px;
  font-weight: 800;
  color: white;
  margin-bottom: 12px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.cta-text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 28px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.cta-button {
  background: white !important;
  color: #8ebf42 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  padding: 24px 48px !important;
  height: auto !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s ease !important;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .youth-container {
    padding: 20px 12px;
  }

  .page-header {
    padding: 16px 18px;
  }

  .header-icon-wrapper {
    width: 42px;
    height: 42px;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-value {
    font-size: 18px;
  }

  .content-card {
    padding: 24px;
  }

  .card-icon {
    width: 64px;
    height: 64px;
  }

  .card-title {
    font-size: 20px;
  }

  .cta-card {
    padding: 40px 28px;
  }

  .cta-icon {
    width: 80px;
    height: 80px;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-text {
    font-size: 15px;
  }
}

@media (max-width: 600px) {
  .youth-container {
    padding: 16px 10px;
  }

  .page-header {
    padding: 14px 16px;
  }

  .header-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .header-icon-wrapper .v-icon {
    font-size: 26px !important;
  }

  .page-title {
    font-size: 18px;
    flex-wrap: wrap;
  }

  .page-title .v-icon {
    font-size: 22px !important;
  }

  .page-subtitle {
    font-size: 12px;
  }

  .hero-card {
    border-radius: 16px;
  }

  .hero-image {
    height: 300px !important;
  }

  .hero-content {
    padding: 16px;
  }

  .hero-content .v-icon {
    font-size: 48px !important;
  }

  .hero-title {
    font-size: 24px;
  }

  .hero-subtitle {
    font-size: 14px;
  }

  .stat-card {
    padding: 14px;
    flex-direction: column;
    text-align: center;
  }

  .stat-icon {
    width: 44px;
    height: 44px;
  }

  .stat-icon .v-icon {
    font-size: 24px !important;
  }

  .stat-label {
    font-size: 10px;
  }

  .stat-value {
    font-size: 16px;
  }

  .content-card {
    padding: 20px;
  }

  .card-icon {
    width: 56px;
    height: 56px;
  }

  .card-icon .v-icon {
    font-size: 32px !important;
  }

  .card-title {
    font-size: 18px;
  }

  .card-text {
    font-size: 13px;
  }

  .card-badge {
    font-size: 10px;
    padding: 6px 12px;
  }

  .cta-card {
    padding: 32px 20px;
    border-radius: 20px;
  }

  .cta-icon {
    width: 72px;
    height: 72px;
  }

  .cta-icon .v-icon {
    font-size: 40px !important;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-text {
    font-size: 14px;
  }

  .cta-button {
    font-size: 14px !important;
    padding: 18px 32px !important;
  }
}
</style>
